import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CoreQuestionsFactoryService, FormQuestionsService, AgentsCacheService } from 'core/services';
import { QuestionBase, QuestionGroup, DropdownQuestion } from 'core/components/forms';
import { UntypedFormGroup } from '@angular/forms';

@Injectable()
export class MarsGroupConfigRankingQuestionsService implements FormQuestionsService {
  protected questions: QuestionBase<any>[];
  protected questionsSubject = new BehaviorSubject(null);
  protected formData: any = {};
  protected form: UntypedFormGroup;

  constructor(protected factory: CoreQuestionsFactoryService, protected translateService: TranslateService) {}

  setForm(form: UntypedFormGroup) {
    this.form = form;
  }

  getFormData(): any {
    return null;
  }

  onDataChanged(newData: any = {}) {
    this.formData = newData;
  }

  getQuestionsObservable() {
    return this.questionsSubject.asObservable();
  }

  getFormQuestions(params: any = {}): Observable<QuestionBase<any>[]> {
    this.questions = [];
    this.onDataChanged();
    this.createQuestions(params);
    return this.getQuestionsObservable();
  }

  createQuestions(params: any = {}) {
    this.questions = [this.getRankingQuestions(params)];
    this.questionsSubject.next(this.questions);
  }

  getRankingQuestions(params) {
    const { group } = params;
    const rankingType =
      group && group.flags.showAlias
        ? 'showAlias'
        : group && group.flags.obfuscateRanking
        ? 'obfuscateRanking'
        : 'showRanking';
    const flags = new QuestionGroup({
      title: 'properties.rankingConfig',
      isSection: true,
      childQuestions: [
        new DropdownQuestion({
          key: 'rankingConfig',
          label: 'properties.rankingConfig',
          class: 'col-2-offset',
          value: rankingType,
          options: [
            { key: 'showRanking', value: this.translateService.instant('properties.showRanking') },
            { key: 'obfuscateRanking', value: this.translateService.instant('properties.obfuscateRanking') },
            { key: 'showAlias', value: this.translateService.instant('properties.showAlias') }
          ]
        })
      ]
    });
    return flags;
  }
}
